// extracted by mini-css-extract-plugin
export var fadeIn = "Square-module--fadeIn--CHckO";
export var square = "Square-module--square--xaIcu";